import { BasicComment } from '../../util/components/comments/comments.interfaces';
import { Field } from '../../util/components/resource/resource-fields/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Document } from '../document/document.model';
import { Staff } from '../staff/staff.model';
import { UploadRequest } from '../upload-request/upload-request.model';

@Endpoint('document-checks', 'DocumentCheck')
export class DocumentCheck extends ApiResource<DocumentCheck> {
  @Field({ label: $localize`Checked at` })
  checkedAt!: Date;

  @Field({ label: $localize`Approved` })
  approved?: null | boolean;

  @Field({ includeFilter: false })
  uploadRequest?: UploadRequest;

  @Field({ includeFilter: false })
  comments!: BasicComment[];

  @Field({ label: $localize`Checked by`, type: () => Staff })
  checkedBy!: Staff;

  @Field({ label: $localize`Document`, type: () => Document })
  document!: Document | null;

  // Virtual column if payment exists with documentCheck id in metadata
  paid!: boolean;
}
